import {eventLoader} from '@otto-ec/global-resources/event-loader';
import SupportPage from './SupportPage'

eventLoader.onAllScriptsExecuted(
    10,
    () => {
        SupportPage.initialize(document)
    }
)